export interface WorkbookQuestionType {
  uuid: string;
  type: WorkbookQuestionTypeType;
  components: WorkbookComponentType[];
  multiple_choice_data: WorkbookQuestionMultipleChoiceDataType[];
  question: string;
  flavor: string;
}

export enum WorkbookQuestionTypeType {
  Code = "Code",
  File = "File",
  Instructions = "Instructions",
  LongForm = "FreeResponse",
  MultipleChoice = "MultipleChoice",
  Table = "Table",
}

export interface WorkbookComponentType {
  uuid: string;
  type: WorkbookComponentTypeType;
  celltype: string;
  choices: { value: string; label: string }[];
  multiple: boolean;
  readonly: boolean;
  rich_text: string;
  title: string;
  value: string;
}

export enum WorkbookComponentTypeType {
  ChoicesField = "ChoicesField",
  CodeField = "CodeField",
  FileField = "FileField",
  RichTextField = "RichTextField",
  TableField = "TableField",
  Text = "Text",
  TextField = "TextField",
}

export interface WorkbookQuestionMultipleChoiceDataType {
  index: number;
  label: string;
  value: string;
}

export interface WorkbookType {
  uuid: string;
  breakout_room_id: string;
  answers: { [key: string]: { [key: string]: string | any[] } };
  flavor: string;
}

export type WorkbookSliceStateType = {
  questions: { [id: string]: WorkbookQuestionType };
  workbooks: { [id: string]: WorkbookType };
};
